import { createApi } from '../callApi';
const contentApi = createApi('CONTENT');

export const fetchDownloadableFiles = (query) => {
    return contentApi({ method: 'GET', target: `/v1/downloads`, query });
};
export const deleteFile = (podcast) => {
    return contentApi({ method: 'DELETE', target: `/v1/podcasts/${podcast}/file` });
};
